import { render, staticRenderFns } from "./DtElogios.vue?vue&type=template&id=5dd2b585"
import script from "./DtElogios.vue?vue&type=script&lang=js"
export * from "./DtElogios.vue?vue&type=script&lang=js"
import style0 from "./DtElogios.vue?vue&type=style&index=0&id=5dd2b585&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports